module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cGF0aCBpZD0icGhvbmUiIGQ9Ik04LjgsOS4yQzgsMTAsOCwxMC44LDcuMiwxMC44UzUuNiwxMCw0LjgsOS4yLDMuMiw3LjYsMy4yLDYuOCw0LDYsNC44LDUuMiwzLjIsMiwyLjQsMiwwLDQuNCwwLDQuNEMwLDYsMS42NDQsOS4yNDQsMy4yLDEwLjhTOCwxNCw5LjYsMTRjMCwwLDIuNC0xLjYsMi40LTIuNFM5LjYsOC40LDguOCw5LjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0yKSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.svg
// module id = uaAc
// module chunks = 1